export default __webpack_public_path__ + "static/media/IC00039-explore.ed1845d9.svg";